/**
 * The availability line of the create and edit dialogs (#2041), under the overlap warning:
 * "Max ist dienstags nur 08:00–13:00 verfügbar". A warning only; the save stays enabled.
 */
import { useLingui } from '@lingui/react';
import { CalendarX2 } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import type { AvailabilityWarning } from '@/types/availability';
import { availabilityLine } from './availabilityLines';

interface ShiftAvailabilityWarningProps {
  availability: AvailabilityWarning | undefined | null;
  employeeName: string;
}

export function ShiftAvailabilityWarning({ availability, employeeName }: ShiftAvailabilityWarningProps) {
  const { i18n } = useLingui();
  if (!availability) return null;
  return (
    <Alert variant="warning" data-testid="availability-warning">
      <CalendarX2 className="h-4 w-4" aria-hidden="true" />
      <AlertTitle>
        {i18n._({ id: 'shifts.availability.title', message: 'Outside availability' })}
      </AlertTitle>
      <AlertDescription data-testid="availability-line">
        {availabilityLine(availability, employeeName, i18n)}
      </AlertDescription>
    </Alert>
  );
}
